import { j as n } from "../../../../jsx-runtime.BREq8dyb.js";
import { sortNumericRange as P } from "@decentriq/utils";
import { faTrash as S } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon as y } from "@fortawesome/react-fontawesome";
import { Stack as M, Tooltip as j, Select as A, Option as t, Checkbox as u, Chip as O, ChipDelete as R, IconButton as D } from "@mui/joy";
import { d as F } from "../../../../lodash.CbaCmyiN.js";
import { memo as I, useCallback as p, useMemo as m } from "react";
import { mapAudienceConditionToPresentation as L } from "../../config.js";
import { AudienceAttributeValueType as Y, AudienceCondition as h } from "../../models.js";
const T = "Select All", w = I(({
  onChange: d,
  attributes: i,
  handleRemove: g,
  attribute: s,
  condition: r,
  values: c
}) => {
  const E = p((e, l) => {
    d({
      attribute: l,
      condition: null,
      values: null
    });
  }, [d]), _ = p((e, l) => {
    d({
      attribute: s,
      condition: l,
      values: null
    });
  }, [s, d]), k = p((e, l) => {
    l.includes(T) || d({
      attribute: s,
      condition: r,
      values: l
    });
  }, [s, r, d]), C = p((e) => (l) => {
    l.stopPropagation(), d({
      attribute: s,
      condition: r,
      values: c?.filter((a) => a !== e) ?? []
    });
  }, [d, s, r, c]), x = m(() => Object.keys(i), [i]), o = m(() => {
    if (!s)
      return [];
    let {
      values: e,
      value_type: l
    } = i[s];
    return l === Y.NUMERIC_RANGE && (e = P(e)), e.map((a) => ({
      label: a,
      value: a
    }));
  }, [s, i]), f = m(() => c?.length === o.length, [c, o]), V = p(() => {
    d({
      attribute: s,
      condition: r,
      values: f ? [] : o.map(({
        value: e
      }) => e)
    });
  }, [f, d, s, r, o]), N = m(() => s ? i[s].filters.map((e) => ({
    label: L[e] ?? e,
    value: e
  })) : [], [s, i]);
  return /* @__PURE__ */ n.jsxs(M, { direction: "row", spacing: 1, sx: {
    "& > *": {
      flex: 1
    },
    pl: 4,
    width: "100%"
  }, children: [
    /* @__PURE__ */ n.jsx(j, { placement: "top", title: x.length !== 0 ? "" : "To select an attribute, choose an audience first", children: /* @__PURE__ */ n.jsx("span", { children: /* @__PURE__ */ n.jsx(A, { disabled: x.length === 0, onChange: E, placeholder: "Add attribute", value: s, children: x.map((e) => /* @__PURE__ */ n.jsx(t, { value: e, children: F(e) }, e)) }) }) }),
    /* @__PURE__ */ n.jsx(j, { placement: "top", title: s ? "" : "To select a condition, add an attribute first", children: /* @__PURE__ */ n.jsx("span", { children: /* @__PURE__ */ n.jsx(A, { disabled: !s, onChange: _, placeholder: "Add condition", value: r, children: N.map(({
      label: e,
      value: l
    }) => /* @__PURE__ */ n.jsx(t, { value: l, children: e }, l)) }) }) }),
    /* @__PURE__ */ n.jsxs(A, { disabled: !s || r === h.EMPTY || r === h.NOT_EMPTY, multiple: !0, onChange: k, placeholder: "Add Value", renderValue: (e) => e.map(({
      value: l
    }) => /* @__PURE__ */ n.jsx(O, { endDecorator: /* @__PURE__ */ n.jsx(R, { onDelete: C(l) }), sx: {
      mr: 1
    }, children: l }, l)), sx: {
      visibility: r && r !== h.EMPTY && r !== h.NOT_EMPTY ? "visible" : "hidden"
    }, value: c ?? [], children: [
      /* @__PURE__ */ n.jsx(t, { onClick: V, value: T, children: /* @__PURE__ */ n.jsx(u, { checked: f, indeterminate: (c?.length ?? 0) > 0 && (c?.length ?? 0) < o.length, label: "Select All" }) }),
      o.map(({
        label: e,
        value: l
      }) => /* @__PURE__ */ n.jsx(t, { value: l, children: /* @__PURE__ */ n.jsx(u, { checked: c?.includes(l) ?? !1, label: e }) }, l))
    ] }),
    /* @__PURE__ */ n.jsx(j, { title: "Remove filter", children: /* @__PURE__ */ n.jsx(D, { onClick: g, sx: {
      "&:hover": {
        backgroundColor: "transparent"
      },
      flex: "unset"
    }, children: /* @__PURE__ */ n.jsx(y, { fixedWidth: !0, icon: S }) }) })
  ] });
});
w.displayName = "AudienceFilter";
export {
  w as default
};
//# sourceMappingURL=AudienceFilter.js.map
